<template>
    <div class="row">
        <div class="col-12 font-weight-500">Endereço do atendimento</div>
        <div class="col-12 mb-1">
            <small>
                <i class="fas fa-map-marker-alt text-success"></i> Origem em:
                <div class="lh-18" v-html="strEnderecoOrigem" style="padding-left: 14px;"></div>
            </small>
        </div>
        <div class="col-12 text-right" v-if="temEnderecoOrigem && statusBotaoCorrigirEndereco">
            <BotaoUsarLocalizacao 
                :corrigir="true" 
                :tipoEndereco="'Origem'" 
                :endereco="enderecoOrigem" 
                :segundaSaida="servico.segundaSaida" 
            />
        </div>
        <div class="col-12 mb-1">
            <small>
                <i class="fas fa-map-marker-alt text-danger"></i> Destino em:
                <div class="lh-18" v-html="strEnderecoDestino" style="padding-left: 14px;"></div>
            </small>
        </div>
        <div class="col-12 text-right" v-if="temEnderecoDestino && enderecoDestino.logradouro != '@BASE PRESTADOR' && statusBotaoCorrigirEndereco">
            <BotaoUsarLocalizacao 
                :corrigir="true" 
                :tipoEndereco="'Destino'" 
                :endereco="enderecoDestino" 
                :segundaSaida="servico.segundaSaida" 
            /> 
        </div>
        <div class="col-12 lh-18 mt-2 pl-1 pr-1 text-center" v-if="exibirPrevisao">
            <table class="table table-bordered table-sm border-left-right-0 m-0" id="previsao-tempo">
                <tr>
                    <td class="border-left-0 small">
                        Previsão {{ $func.tempoEmMinutos(servico.previaServico) }} min
                        <i class="fa fa-history ml-2"></i>
                        <br>
                        <small>
                            Inserido em {{ $func.removeSegundos(servico.dataCadastroServico) }}
                        </small>
                    </td>
                    <td class="border-right-0 small">
                        <div v-if="$func.isEmpty(servico.dataHorarioChegada)" v-html="textoTempoRestanteAtualizar"></div>
                        <div v-else v-html="montarTempoChegada()"></div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="col-12 mt-1" v-if="exibirRastreioPrestadores == 'S'">
            <small class="text-warning">
                <i class="fa fa-info-circle" aria-hidden="true"></i> Atendimento rastreável
            </small>
            <button type="button" class="btn btn-purple btn-sm font-11 float-right mt-1" @click="atualizarDados">
                Atualizar rastreio <i class="fa fa-redo"></i>
            </button>
        </div>
    </div>
</template>

<script>
import BotaoUsarLocalizacao from '@/components/Botoes/BotaoUsarLocalizacao.vue';
import { mapActions, mapState } from "vuex";

const arrayStatus = [
    'PRESTADOR_ACIONADO',
    'PRESTADOR_A_CAMINHO',
    'PRESTADOR_CHEGOU_LOCAL',
    'VIAJANDO_PARA_DESTINO',
    'FINALIZADO'
];

export default {
    data() {
        return {
            strEnderecoOrigem: '',
            strEnderecoDestino: '',
            tempoRestante: 0,
            textoTempoRestante: '',
            textoTempoChegada: '',
            intevaloAtualizaTempoRestante: null,
        }
    },
    components: {
        BotaoUsarLocalizacao
    },
    props: {
        enderecoOrigem: {
            type: Object,
            default: () => { return {}; }
        },
        enderecoDestino: {
            type: Object,
            default: () => { return {}; }
        },
        servico: {
            type: Object,
            default: () => { return {}; }
        },
        status: String,
        exibirRastreioPrestadores: String
    },
    watch: {
        enderecoOrigem() {
            this.strEnderecoOrigem = this.montarEndereco(this.enderecoOrigem);
        },
        enderecoDestino() {
            this.strEnderecoDestino = this.montarEndereco(this.enderecoDestino);
        },
        servico: function () {
            const self = this;
            self.montarTempoRestante();
        }
    },
    computed: {
        ...mapState('Atendimento', {
            temServicos: 'temServicos',
            idAtendimento: 'idAtendimentoUrl'
        }),
        temEnderecoOrigem() {
            return this.strEnderecoOrigem != 'Não infornado';
        },
        temEnderecoDestino() {
            return this.strEnderecoDestino != 'Não infornado';
        },
        textoTempoRestanteAtualizar() {
            if (this.$func.isEmpty(this.textoTempoRestante)) {
                return '';
            }
            return this.textoTempoRestante;
        },
        exibirPrevisao() {
            return this.temServicos && arrayStatus.indexOf(this.status) > -1;
        },
        statusBotaoCorrigirEndereco() {
            return [
                'PRESTADOR_A_CAMINHO',
                'PRESTADOR_CHEGOU_LOCAL',
                'VIAJANDO_PARA_DESTINO',
                'FINALIZADO',
                'CANCELADO'
            ].indexOf(this.status) < 0;
        }
    },
    methods: {
        ...mapActions("Atendimento", ["buscarDadosAtendimento"]),
        montarEndereco(endereco) {
            if (endereco.logradouro == '@BASE PRESTADOR') {
                return 'O destino deste atendimento será a base do prestador';
            }

            const str = this.$func.montarEndereco(endereco);
            if (str) {
                return str;
            }
            return 'Não infornado';
        },
        montarTempoChegada() {
            this.tempoRestante = this.calcularTempoRestante();
            const tempoChegada = this.calcularTempoChegada();
            let str = ''
            if (this.tempoRestante <= 0) {
                str += `<div class="text-success">No prazo</div>`;
            }

            return `${str} Chegou com ${tempoChegada} min.`;
        },
        calcularTempoChegada() {
            if (this.$func.isEmpty(this.servico.dataCadastroServico) || this.$func.isEmpty(this.servico.dataHorarioChegada)) {
                return 0;
            }
            const chegada = this.$moment(this.servico.dataHorarioChegada, "DD/MM/YYYY HH:mm:ss");
            const acionado = this.$moment(this.servico.dataCadastroServico, "DD/MM/YYYY HH:mm:ss");
            const duration = this.$moment.duration(chegada.diff(acionado));
            let tempoChegada = parseInt(duration.asMinutes());
            return tempoChegada < 0 ? (tempoChegada *-1) : tempoChegada;
        },
        exibirDataRastreio() {
            let html = '';

            const dataUltimaAtualizacao = this.$moment(this.servico.posicoesPrestador[0].dataHora, "DD/MM/YYYY HH:mm:ss");
            const agora = this.$moment();
            const diferenca = agora.diff(dataUltimaAtualizacao);
            const minutos = parseInt(this.$moment.duration(diferenca).asMinutes());
            const horas = parseInt(this.$moment.duration(diferenca).asHours());
            const dias = parseInt(this.$moment.duration(diferenca).asDays());

            html += `<small>Última atualização: há `;
            if (dias == 1) {
                html += `${dias} dia`;
            } else if (dias > 1) {
                html += `${dias} dias`;
            } else if (horas == 1) {
                html += `${horas} hora`;
            } else if (horas > 1) {
                html += `${horas} horas`;
            } else if (minutos == 1) {
                html += `${minutos} minuto`;
            } else if (minutos > 1) {
                html += `${minutos} minutos`;
            } else {
                html += 'menos de 1 minuto'
            }
            html += ' atrás</small>';

            return html;
        },
        calcularTempoRestante() {
            if (
                this.temServicos && arrayStatus.indexOf(this.status) > -1 && 
                !this.$func.isEmpty(this.servico.previaServico) && 
                !this.$func.isEmpty(this.servico.dataExecucaoServico)
            ) {
                const previsaoMinutos = this.$func.tempoEmMinutos(this.servico.previaServico);
                const dataLimite = this.$moment(this.servico.dataExecucaoServico, "DD/MM/YYYY HH:mm:ss").add(previsaoMinutos, 'minutes');
                const agora = this.$moment();
                const diferenca = agora.diff(dataLimite);
                
                return parseInt(this.$moment.duration(diferenca).asMinutes());
            }

            return 0;
        },
        montarTempoRestante() {
            if (this.$func.isEmpty(this.servico.dataHorarioChegada)) {
                this.tempoRestante = this.calcularTempoRestante();

                if (this.tempoRestante <= 0) {
                    this.textoTempoRestante = `<span class="text-success">Restando ${this.tempoRestante * -1} min.</span>`;
                } else {
                    this.textoTempoRestante = `<span>Restando 0 min.</span>`;
                }
            } else {
                clearInterval(this.intevaloAtualizaTempoRestante);
            }
        },
        atualizarTempoRestante() {
            this.intevaloAtualizaTempoRestante = setInterval(() => {
                this.montarTempoRestante();
            }, 15000);
        },
        atualizarDados() {
            this.buscarDadosAtendimento({
                idAtendimento: this.idAtendimento,
                atualizar: true,
            });            
        }
    },
    created() {
        this.strEnderecoOrigem = this.montarEndereco(this.enderecoOrigem);
        this.strEnderecoDestino = this.montarEndereco(this.enderecoDestino);

        this.montarTempoRestante();
        this.atualizarTempoRestante();
    }
}
</script>

<style>
    .border-left-right-0 {
        border-left-width: 0 !important;
        border-right-width: 0 !important;
    }
    .border-left-0 {
        border-left-width: 0 !important;
    }
    .border-right-0 {
        border-right-width: 0 !important;
    }
    #previsao-tempo td {
        vertical-align: middle;
    }
</style>
